// Theme Toggle Functionality
(function() {
    'use strict';
    
    // Function to apply theme
    function applyTheme(theme) {
        console.log('[ThemeToggle] Applying theme:', theme);
        document.body.classList.remove('dark-mode', 'light-mode');
        
        if (theme === 'dark') {
            document.body.classList.add('dark-mode');
        } else if (theme === 'light') {
            document.body.classList.add('light-mode');
        } else {
            // Auto mode - check system preference
            if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
                document.body.classList.add('dark-mode');
            }
        }
        console.log('[ThemeToggle] Body classes after apply:', document.body.className);
    }
    
    // Initialize theme
    function initTheme() {
        console.log('[ThemeToggle] Initializing theme toggle...');
        
        // Check for saved theme preference or default to 'auto'
        const savedTheme = localStorage.getItem('theme');
        console.log('[ThemeToggle] Saved theme:', savedTheme);
        applyTheme(savedTheme);
        
        // Get all toggle buttons (can be multiple on the page)
        const toggles = document.querySelectorAll('.gh-theme-toggle');
        console.log('[ThemeToggle] Found toggle buttons:', toggles.length);
        
        // Add click handler to each toggle
        toggles.forEach(function(toggle, index) {
            console.log('[ThemeToggle] Adding listener to toggle', index, toggle);
            toggle.addEventListener('click', function(e) {
                console.log('[ThemeToggle] Main theme toggle clicked!');
                e.preventDefault();
                const isDark = document.body.classList.contains('dark-mode');
                const newTheme = isDark ? 'light' : 'dark';
                
                localStorage.setItem('theme', newTheme);
                applyTheme(newTheme);
            });
        });
        
        // Listen for system theme changes
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function(e) {
            const savedTheme = localStorage.getItem('theme');
            if (!savedTheme || savedTheme === 'auto') {
                applyTheme('auto');
            }
        });
    }
    
    // Run when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTheme);
    } else {
        // Small delay to ensure all elements are rendered
        setTimeout(initTheme, 0);
    }
})();